// src/services/reviewService.js

import axiosInstance from "../api/axiosInstance";

const handleRequest = async (requestFn) => {
  try {
    const response = await requestFn();
    return { success: true, data: response.data };
  } catch (error) {

    return {
      success: false,
      data: null,
      message:
        error.message === "Network Error"
          ? "Cannot reach the server. Please try again later."
          : "Something went wrong. Please try again.",
    };
  }
};

/* ===============================
   REVIEWS (PUBLIC)
================================ */

export const fetchAllReviews = () =>
  handleRequest(() => axiosInstance.get(`/public/reviews`));

export const fetchReviewSummary = () =>
  handleRequest(() => axiosInstance.get(`/public/reviews/summary`));

/* ===============================
   REVIEWS (AUTHENTICATED)
================================ */

export const addOrUpdateReview = (payload) =>
  handleRequest(() => axiosInstance.post(`/public/reviews`, payload));

export const deleteMyReview = () =>
  handleRequest(() => axiosInstance.delete(`/public/reviews/delete`));
